import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const ProtectedRoute = () => {
	const vendorToken = localStorage.getItem('selli-vendor-accessToken');
	const adminToken = localStorage.getItem('token');
	const slug = localStorage.getItem('slug');
	const location = window.location.pathname.split('/');
	if (location.includes(slug as string) && !vendorToken) {
		return <Navigate to={`/${slug}/login`} replace />;
	}

	if (!location.includes(slug as string) && !adminToken) {
		return <Navigate to="/login" replace />;
	}

	return <Outlet />;
};

export default ProtectedRoute;
